module.exports = __webpack_public_path__ + "img/shift-scheduling.3efefeb8.png";